import * as React from 'react';
import { AccountLevelEnum, CarrierPaymentTypeEnum } from '@app/app.enum';
import { IIntlProps } from '@app/models';
import { Grid, TextField, Typography } from '@material-ui/core';
import { Field, FormikProps, FormikValues } from 'formik';
import { injectIntl } from 'react-intl';
import CustomTooltip from '../shared/custom-tooltip.component';
import Icon from '../shared/icon.component';
import classNames from 'classnames';

interface IMRAConfigComponentProps extends IIntlProps {
	formikProps: FormikProps<FormikValues>;
	paymentType: CarrierPaymentTypeEnum;
	accountLevel: AccountLevelEnum;
}

const MRAConfigComponent: React.FunctionComponent<IMRAConfigComponentProps> = ({
	formikProps,
	intl,
	paymentType,
	accountLevel,
}) => (
	<Grid container={true} className='mt-2'>
		<Grid container={true} item={true} xs={12} className='mb-1' alignItems='center'>
			<Typography
				noWrap={true}
				color={'inherit'}
				variant='body1'
				className={classNames('display-inline-block', paymentType !== CarrierPaymentTypeEnum.Postpaid && 'opacity-60')}
			>
				{intl.formatMessage({
					id: 'app.carrier-account.MRA-section-header',
				})}
			</Typography>
			{accountLevel === AccountLevelEnum.Customer && (
				<CustomTooltip
					items={JSON.parse(
						paymentType !== CarrierPaymentTypeEnum.Postpaid
							? intl.formatMessage({
									id: 'app.carrier-account.config.MRA-label-disabled.tooltip-message',
							  })
							: intl.formatMessage({
									id: 'app.carrier-account.config.MRA-label-enabled.tooltip-message',
							  })
					)}
					className='display-inline-block ml-1'
				>
					<Typography>
						<Icon name='info-circle' />
					</Typography>
				</CustomTooltip>
			)}
		</Grid>
		<Grid item={true} container={true} justifyContent='flex-start' alignItems='center' spacing={2}>
			<Grid item={true} sm={6}>
				<Field
					name='mraReturnsMid'
					variant='outlined'
					label={intl.formatMessage({
						id: 'app.carrier-account.config.returns-mid-label',
					})}
					component={TextField}
					type='text'
					value={formikProps.values.mraReturnsMid}
					fullWidth={true}
					onChange={(e: React.ChangeEvent) => formikProps.handleChange('mraReturnsMid')(e)}
					disabled={paymentType !== CarrierPaymentTypeEnum.Postpaid}
					error={
						!!(
							(formikProps.values.mraReturnsMid?.length || formikProps.submitCount) &&
							!!formikProps.errors.mraReturnsMid
						)
					}
					helperText={
						formikProps.values.mraReturnsMid?.length || formikProps.submitCount
							? formikProps.errors.mraReturnsMid
							: null
					}
				/>
			</Grid>
			<Grid item={true} sm={6}>
				<Field
					name='mraAccountCode'
					variant='outlined'
					label={intl.formatMessage({
						id: 'app.carrier-account.config.mra-account-code-label',
					})}
					component={TextField}
					type='text'
					value={formikProps.values.mraAccountCode}
					fullWidth={true}
					onChange={(e: React.ChangeEvent) => formikProps.handleChange('mraAccountCode')(e)}
					disabled={paymentType !== CarrierPaymentTypeEnum.Postpaid}
					error={
						!!(
							(formikProps.values.mraAccountCode?.length || formikProps.submitCount) &&
							!!formikProps.errors.mraAccountCode
						)
					}
					helperText={
						formikProps.values.mraAccountCode?.length || formikProps.submitCount
							? formikProps.errors.mraAccountCode
							: null
					}
				/>
			</Grid>
		</Grid>
	</Grid>
);

export default injectIntl(MRAConfigComponent);



// WEBPACK FOOTER //
// ./src/components/carriers/mra-config-component.tsx